import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

/** Polls /notifications/unread every 30s when user is logged in and tab is visible. */
export function useNotifications() {
  const { user } = useAuth();
  const sinceRef = useRef(new Date(Date.now() - 60_000).toISOString());
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!user) return;
    if (document.hidden) return;

    const tick = async () => {
      if (document.hidden) return;
      try {
        const { data } = await api.get(`/notifications/unread?since=${encodeURIComponent(sinceRef.current)}`);
        for (const item of data.items || []) {
          toast(item.title, {
            description: item.body,
            duration: 8000,
            action: item.type === "ticket" ? { label: "Ver", onClick: () => window.location.href = "/app/suporte" } : undefined,
          });
        }
        if (data.now) sinceRef.current = data.now;
      } catch {}
    };

    tick();
    intervalRef.current = setInterval(tick, 30_000);
    const onVisible = () => { if (!document.hidden) tick(); };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      clearInterval(intervalRef.current);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [user]);
}
